module.exports = __webpack_public_path__ + "static/media/dine-in.1e8f5361.svg";